// src/utilities/credentialOwners.js — SOUND-787
//
// A parent company's Credentials tab now rolls up its child companies'
// credentials (sound-api returns parent + children for `?companyId=<parent>`).
// Once rows can come from more than one company, each row has to say whose it
// is — a parent cannot rotate a child's credential, so "whose" is not cosmetic.
//
// Same rule as MidsTab: derived from the DATA, not the company type. Any row
// owned by a company other than the one being viewed means this is an
// aggregated view. On a leaf client every row would show the same name, so the
// Owner column only earns its place when this is true.

/**
 * @param {Array<{companyId?: string}>} rows   credential list rows
 * @param {string} viewedCompanyId             the company whose tab this is
 * @returns {boolean}
 */
export function isAggregatedCredentialView(rows, viewedCompanyId) {
  if (!Array.isArray(rows) || !viewedCompanyId) return false;
  return rows.some((r) => Boolean(r?.companyId) && r.companyId !== viewedCompanyId);
}

/**
 * The owner label for a row. `companyName` is resolved server-side from
 * companyId (services/credentialNames.mjs); an unresolvable owner comes back
 * null and renders as a dash rather than a guessed id.
 */
export function credentialOwnerLabel(row) {
  return row?.companyName || "—";
}
